// Bileli · modules/media/lib — shared localStorage idioms for the upload persistence stores (mirrors
// frontend/web): JSON read/write, TTL prune-on-read, best-effort (never throws), and a subscribe that
// hears BOTH the cross-tab `storage` event and a same-tab CustomEvent (the native `storage` event only
// fires in OTHER tabs).

export function lsRead<T>(key: string): T | undefined {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : undefined;
  } catch {
    return undefined;
  }
}

export function lsWrite(key: string, value: unknown, event: string): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    document.dispatchEvent(new CustomEvent(event));
  } catch {
    // best-effort (quota / private mode)
  }
}

export function lsSubscribe(key: string, event: string, listener: () => void): () => void {
  const onStorage = (e: StorageEvent) => {
    if (e.key === key) listener();
  };
  const onLocal = () => listener();
  window.addEventListener('storage', onStorage);
  document.addEventListener(event, onLocal);
  return () => {
    window.removeEventListener('storage', onStorage);
    document.removeEventListener(event, onLocal);
  };
}

export const MEDIA_TTL_MS = 24 * 60 * 60 * 1000; // 24h — matches frontend/web
